export enum BaseReportTypeEnums {
    PrincipalReports = 1,
    LPCPrincipalReports = 100,
    BQLateContributionReports = 101,
    DepositReports = 2,
    DepositoryYearEndSummaries = 3,
    CreditCardReport = 4,
    ReimbursementReports = 5,
    PayrollItemizationReports = 6,
    OtherPeriodicReports = 8,
    SubvendorReports = 7,
    LateContributionReports = 11,
    BankExpenditureItemizationReports = 12,
    IEPACReports = 301,
    IEPACPeriodicReports = 302,
    DonationReports = 201
  }
